import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementsByClassName("splide").length >= 1) {
        new Splide( '#sponsorsplide', {
            type   : 'loop',
            drag   : 'free',
            focus  : 'center',
            height : 'fit-content',
            pagination : false,
            gap : '64px',
            // gap : '48px',
            perPage: 5,
            arrows: false,
            autoScroll: {
                speed: 0.1,
              },
        } ).mount({AutoScroll});
    // } ).mount();
    }

    // if (document.getElementsByClassName("splide").length >= 1) {
    //     new Splide('#sponsorplide', {
    //         type: 'loop',
    //         drag: 'free',
    //         focus: 'center',
    //         perPage: 4,
    //         arrows: false,
    //         height : 'fit-content',
    //         gap: '10px',
    //         pagination: false,
    //         autoScroll: {
    //             speed: 0.3,
            
    //         },
    //     }).mount({ AutoScroll });
    // }


    if(document.getElementById('disciplinessplide')) {
        new Splide( '#disciplinessplide', {
            type   : 'loop',
            drag   : false,
            // focus  : 'center',
            height : 'inherit',
            pagination : false,
            perPage: 1,
            arrows: true,
        } ).mount();
    }

    // if(document.getElementById('nieuwssplide')) {
    //     new Splide( '#nieuwssplide', {
    //         type   : 'loop',
    //         padding: '5rem',
    //         // gap: '1rem',
    //         pagination : false,
    //         // perPage: 1,
    //         arrows: true,
    //         breakpoints:{
    //             992:{
    //                 arrows: false
    //             }
    //         }
    //     } ).mount();
    // }
    if(document.getElementById('wdwsplide')) {
        new Splide( '#wdwsplide', {
            type   : 'loop',
            padding: '6rem',
            gap: '1rem',
            pagination : false,
            perPage: 1,
            arrows: true,
            breakpoints:{
                992:{
                    arrows: false
                }
            }
        } ).mount();
    }
})

